import React from "react"
import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  NumberField,
  ReferenceManyField,
  Datagrid,
  Pagination,
  FunctionField,
  WrapperField,
  ChipField,
  SingleFieldList,
  ArrayField,
  Labeled, BooleanField
} from "react-admin";
import { Divider, Box, Stack } from "@mui/material"
import PoiTypeIcon from "src/common/PoiTypeIcon"
import PoiType from "src/models/PoiType"

const PoiTypeShow = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <Box sx={{ display: "flex", gap: 12 }}>
          <Stack spacing={2}>
            <Labeled>
              <TextField source="id" />
            </Labeled>
            <Labeled>
              <WrapperField label="Name" sortBy="name">
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <FunctionField render={(poiType: PoiType) => <PoiTypeIcon poiType={poiType} />} />
                  <TextField source="name" />
                </Box>
              </WrapperField>
            </Labeled>
            <Labeled>
              <TextField source="slug" />
            </Labeled>
            <Labeled>
              <NumberField source="pois_count" />
            </Labeled>
            <Labeled>
              <DateField source="created_at" />
            </Labeled>
            <Labeled>
              <DateField source="updated_at" />
            </Labeled>
          </Stack>
          <Stack spacing={2}>
            <Labeled>
              <BooleanField source="featured" />
            </Labeled>
            <Labeled>
              <BooleanField source="is_searchable" />
            </Labeled>
            <Labeled>
              <ChipField source="default_category.name" label="Default category" sx={{ alignSelf: "flex-start" }} />
            </Labeled>
            <Labeled>
              <ArrayField label="Assigned attributes" source="attributes">
                <SingleFieldList linkType="show" resource="attributes">
                  <ChipField source="name" size="small" />
                </SingleFieldList>
              </ArrayField>
            </Labeled>
          </Stack>
        </Box>

        <Divider />
        <ReferenceManyField pagination={<Pagination />} perPage={25} reference="pois" target="type_id" label="Pois" sort={{ field: "created_at", order: "DESC" }}>
          <Datagrid rowClick="show">
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="publish_state" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
          </Datagrid>
        </ReferenceManyField>
      </SimpleShowLayout>
    </Show>
  )
}

export default PoiTypeShow
